import React from 'react';
import {
  Button,
  Col, Grid, Layout, Row, Space, message,
} from 'antd';
import MinimalHeaderComponent from 'components/reusables/MinimalHeader/MinimalHeaderComponent';
import MinimalFooterComponent from 'components/reusables/MinimalFooter/MinimalFooterComponent';
import Link from 'antd/lib/typography/Link';
import { StorageInterface } from 'store/StorageInterface';
import { useSelector } from 'react-redux';
import { AppConfig } from '../../../ENV';
import './TransferNow.scss';
import logoTrfOnline from "../../../assets/namespace/logos/autofact_transferencias_online.svg";
import goToLink from "../../../assets/namespace/icons/goToLink.svg";
import TransferenceCalculatorComponent from "components/reusables/TransferenceCalculatorComponent/TransferenceCalculatorComponent";
import CTAModalComponent from "components/reusables/CTAModal/CTAModalComponent";
import { QuestionCircleFilled, ShareAltOutlined } from '@ant-design/icons';
const shareURL = 'https://simulador-transferencia.autofact.cl/'

const { useBreakpoint } = Grid;

function TransferNowContainer() {
  const dsctCode = AppConfig.dsct_code;
  const userData = useSelector((state: StorageInterface) => {
    return state.userDataSlice;
  });

  const [messageApi, contextHolder] = message.useMessage();

  const ctaUrl = AppConfig.cta_url;

  const screens = useBreakpoint();
  return (
    <Layout id="container">
      {contextHolder}
      <Space id="body" direction="vertical" size={screens["lg"] ? 35 : 24}>
        <MinimalHeaderComponent
          showLink={false}
          transferenceHref="https://www.autofact.cl/transferencias"
          centerLogo={screens["lg"] ? true : false}
        ></MinimalHeaderComponent>
        <Layout style={{ padding: "0px 1rem 1rem 1rem", alignItems: "center" }}>
          <Row style={{ justifyContent: "center" }}>
            <Col
              xs={24}
              md={24}
              style={{ maxWidth: `${!screens["lg"] ? "630px" : "950px"}` }}
            >
              <Space size={24} direction="vertical">
                {/* <div> */}
                {/* TODO: move to component */}
                <Row
                  style={{ paddingTop: `${!screens["lg"] ? "5px" : "20px"}` }}
                >
                  <Col>
                    <Space
                      size={24}
                      direction="vertical"
                      style={{ alignItems: "center" }}
                    >
                      <Col>
                        <img
                          src={logoTrfOnline}
                          alt="Transferencia Online, Autofact"
                          style={{
                            width: `${screens["lg"] ? "250px" : "161px"}`,
                            margin: "auto",
                          }}
                        />
                      </Col>
                      <Space
                        size={screens["lg"] ? 45 : 24}
                        direction="vertical"
                        className="TransferNow"
                      >
                        <div className={"bodyInfo"}>
                          {
                            <span style={{ fontWeight: "400" }}>
                              Ya conoces lo{" "}
                              <span style={{ fontWeight: "700" }}>
                                fácil y rápido
                              </span>{" "}
                              que es transferir un vehículo con Autofact
                            </span>
                          }
                        </div>
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {dsctCode && dsctCode !== "" ? (
                            <CTAModalComponent
                              email={userData.email}
                              fullName={userData.fullname}
                              role={userData.role}
                              dsctCode={dsctCode}
                            />
                          ) : (
                            <div
                              className="trasferLinkBtn"
                              style={{
                                width: "100%",
                                maxWidth: "275px",
                                margin: "auto",
                              }}
                            >
                              <Link
                                id={"simTrf-btn-init-transference"}
                                target={"_blank"}
                                title="Transferir ahora..."
                                href={`${ctaUrl}?mail=${userData.email}&nombre=${userData.fullname}&role=${userData.role}`}
                              >
                                <Row className="transferenceLink">
                                  <Col>
                                    <img
                                      src={goToLink}
                                      alt={"InitTransference"}
                                    />
                                  </Col>
                                  <Col>
                                    <div className={""}>Transferir ahora</div>
                                  </Col>
                                </Row>
                              </Link>
                            </div>
                          )}
                        </div>
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <TransferenceCalculatorComponent>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                              <h2 className='calc-title'>Calcula y simula tu transferencia</h2>
                            </div>
                          </TransferenceCalculatorComponent>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                          <Space size={24} direction='vertical' style={{ alignItems: 'center' }}>
                            <Link
                              target={"_blank"}
                              title="FAQ"
                              href={
                                "https://www.autofact.cl/transferencias?active=service-cost#faq"
                              }
                            >
                              <Row className="links" style={{ paddingTop: "0px" }}>
                                <Col style={{ paddingRight: "10px", display: "flex" }}>
                                  <QuestionCircleFilled style={{ color: '#004CC6', fontSize: '16px' }} />
                                </Col>
                                <Col>
                                  <div className={"faq-text"}>Preguntas frecuentes</div>
                                </Col>
                              </Row>
                            </Link>
                            <Row className="links" style={{ paddingTop: "0px" }}>
                              <Col>
                                <Button
                                  type='link'
                                  style={{
                                    fontSize: ' 16px',
                                    fontStyle: 'normal',
                                    fontWeight: 600,
                                    lineHeight: '24px',
                                  }}
                                  className='share-button'
                                  icon={<ShareAltOutlined style={{ color: '#004CC6', fontSize: '16px' }} />}
                                  onClick={() => {
                                    if (navigator.share) {
                                      navigator.share({
                                        title: 'Simulador de Transferencia de autos - Autofact',
                                        text: 'Revisa el valor de una  transferencia de un auto',
                                        url: shareURL,
                                      })
                                        .then(() => console.log('Successful share'))
                                        .catch((error) => console.log('Error sharing', error));
                                    } else if (navigator.clipboard) {
                                      try {
                                        navigator.clipboard.writeText(shareURL);
                                        messageApi.open({
                                          type: 'success',
                                          content: 'Se copio la url al clipboard',
                                        });
                                      } catch (error) {
                                        messageApi.open({
                                          type: 'error',
                                          content: 'Ocurrió un error al compartir la url',
                                        });
                                      }
                                    }
                                  }}
                                >
                                  Compartir Simulador
                                </Button>
                              </Col>
                            </Row>
                            <Link
                              disabled={false}
                              target={"_self"}
                              title="Volver al inicio..."
                              href={"https://www.autofact.cl/"}
                            >
                              <Row className="linksToHome">
                                <Col>
                                  <div className='home-link' >{"Volver al home"}</div>
                                </Col>
                              </Row>
                            </Link>
                          </Space>
                        </div>
                        {/* <BackToHomeLink label={"Volver al home"}></BackToHomeLink> */}
                      </Space>
                    </Space>
                  </Col>
                </Row>
                {/* end move to component */}
                {/* </div> */}
                <div className="" style={{ alignItems: "center" }}></div>
              </Space>
            </Col>
          </Row>
        </Layout>
      </Space>
      <div id="footer">
        <MinimalFooterComponent />
      </div>
    </Layout>
  );
}

export default TransferNowContainer;
